import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectForumTopicsQueryItems } from '../../../../../redux/forum-topics/selector';
import { selectForumsListItems} from '../../../../../redux/forums/selector';
import { forumTopics } from '../../../../../redux/forum-topics/action';
import ForumTopicComponent from '../components/forum-topic.component';
import { forums } from '../../../../../redux/forums/action';
import { selectListItems } from '../../../../../redux/library/selector';


const AgencyForumTopic = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const libraryData = useSelector(selectListItems)
  const forumTopicsQuery = useSelector(selectForumTopicsQueryItems);
  const forumsItems = useSelector(selectForumsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedForumTopic, setSelectedForumTopic] = useState<any>({});

  const fetchForumTopicQueryById = () => {
    dispatch(forumTopics.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/query`,
      entity: 'forumTopics',
      jsonData: {
        Records: [
          {
            
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedForumTopic({ ...selectedForumTopic, [field]: event });
  }

  useEffect(() => {
    dispatch(forums.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forums/list`,
          entity: 'forums',
          jsonData: {}
        })).then(() => {
            if (parmas?.id > 0) {
                fetchForumTopicQueryById()
              setIsLoading(false)
            } else {
              setIsLoading(false)
            }
          })
  }, []);

  useEffect(() => {
    if (isQuery) {
        setSelectedForumTopic(forumTopicsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(forumTopics.resetAction({ actionType: 'update' }))
      await dispatch(forumTopics.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics`,
        entity: 'forumTopics',
        jsonData: {
          Records: [
            selectedForumTopic
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(forumTopics.resetAction({ actionType: 'create' }))
      await dispatch(forumTopics.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics`,
        entity: 'forumTopics',
        jsonData: {
          Records: [
            selectedForumTopic
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/agencies/forum/forum-topics');
  }

  return (
    <>
      {forumTopicsQuery?.isLoading ? <PageLoader /> :
        <ForumTopicComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedForumTopic={selectedForumTopic}
          libraryData={libraryData}
          back={back}
          handleFormSubmit={handleFormSubmit}
          forums={forumsItems?.result?.items} 
        />
      }
    </>
  );
}

export default AgencyForumTopic;
